const API_URL = process.env.REACT_APP_API_URL

export const loginUrl = `${API_URL}/api/auth/login`
export const meUrl = `${API_URL}/api/auth/me`
export const requestForgottenPasswordUrl = `${API_URL}/api/auth/password/forget`
export const resetPasswordUrl = `${API_URL}/api/auth/password/reset`

export const fetchLicensesUrl = `${API_URL}/api/licenses`
export const fetchLicenseByIdUrl = `${API_URL}/api/licenses`
export const createLicenseUrl = `${API_URL}/api/licenses/create`
export const updateLicenseUrl = `${API_URL}/api/licenses/update`
export const deleteLicenseUrl = `${API_URL}/api/licenses/delete`
export const suspendLicenseUrl = `${API_URL}/api/licenses/suspend`
export const activateLicenseUrl = `${API_URL}/api/licenses/activate`

export const fetchUsersUrl = `${API_URL}/api/users`
export const fetchUserByIdUrl = `${API_URL}/api/users`
/** GET /api/users/online — who is connected + count (admin role 2 only) */
export const usersOnlineUrl = `${API_URL}/api/users/online`
export const fetchAllUsersUrl = `${API_URL}/api/users/all`
export const createUserUrl = `${API_URL}/api/users/create`
export const updateUserUrl = `${API_URL}/api/users/update`
export const deleteUserUrl = `${API_URL}/api/users/delete`
export const suspendUserUrl = `${API_URL}/api/users/suspend`
export const activateUserUrl = `${API_URL}/api/users/activate`
export const activateUsersExceptUrl = `${API_URL}/api/users/activate-except`
export const suspendUsersExceptUrl = `${API_URL}/api/users/suspend-except`

export const fetchEstablishementsUrl = `${API_URL}/api/establishements`
export const fetchEstablishementByIdUrl = `${API_URL}/api/establishements`
export const fetchAllEstablishementsUrl = `${API_URL}/api/establishements/all`
export const createEstablishementUrl = `${API_URL}/api/establishements/create`
export const updateEstablishementUrl = `${API_URL}/api/establishements/update`
export const deleteEstablishementUrl = `${API_URL}/api/establishements/delete`
export const suspendEstablishementUrl = `${API_URL}/api/establishements/suspend`
export const activateEstablishementUrl = `${API_URL}/api/establishements/activate`

export const fetchClassesUrl = `${API_URL}/api/classes`
export const fetchClasseByIdUrl = `${API_URL}/api/classes`
export const createClasseUrl = `${API_URL}/api/classes/create`
export const updateClasseUrl = `${API_URL}/api/classes/update`
export const deleteClasseUrl = `${API_URL}/api/classes/delete`
export const suspendClasseUrl = `${API_URL}/api/classes/suspend`
export const activateClasseUrl = `${API_URL}/api/classes/activate`
export const fetchAllClassesUrl = `${API_URL}/api/classes/all`

export const fetchSubjectsUrl = `${API_URL}/api/subjects`
export const fetchSubjectByIdUrl = `${API_URL}/api/subjects`
export const createSubjectUrl = `${API_URL}/api/subjects/create`
export const updateSubjectUrl = `${API_URL}/api/subjects/update`
export const deleteSubjectUrl = `${API_URL}/api/subjects/delete`
export const suspendSubjectUrl = `${API_URL}/api/subjects/suspend`
export const activateSubjectUrl = `${API_URL}/api/subjects/activate`
export const fetchAllSubjectsUrl = `${API_URL}/api/subjects/all`

// Grade & Tabulation Endpoints
export const createGradeUrl = `${API_URL}/api/grades`
export const updateGradeUrl = `${API_URL}/api/grades`
export const deleteGradeUrl = `${API_URL}/api/grades`
export const approveGradeUrl = `${API_URL}/api/grades`
export const rejectGradeUrl = `${API_URL}/api/grades`
export const fetchGradesUrl = `${API_URL}/api/grades`
export const fetchGradeByIdUrl = `${API_URL}/api/grades`

// Tabulation Endpoints
export const createTabulationUrl = `${API_URL}/api/grades/tabulations/create`
export const updateTabulationUrl = `${API_URL}/api/grades/tabulations/update`
export const deleteTabulationUrl = `${API_URL}/api/grades/tabulations/delete`
export const submitTabulationUrl = `${API_URL}/api/grades/tabulations`
export const fetchTabulationsUrl = `${API_URL}/api/grades/tabulations`
export const fetchTabulationByIdUrl = `${API_URL}/api/grades/tabulations`
export const fetchApprovalQueueUrl = `${API_URL}/api/grades/tabulations/approval-queue`
export const fetchSubmissionDetailsUrl = `${API_URL}/api/grades/tabulations/submission`
export const detectMissingGradesUrl = `${API_URL}/api/grades/tabulations`
export const reviewTabulationUrl = `${API_URL}/api/grades/tabulations`
export const fetchStudentGradesUrl = (studentId: string) => `${API_URL}/api/grades/tabulations/student/${studentId}/grades`

// Bulletin Endpoints
export const fetchBulletinUrl = `${API_URL}/api/bulletin`
export const fetchBulletinsUrl = `${API_URL}/api/bulletin`

export const fetchExercicesUrl = `${API_URL}/api/exercices`
export const fetchExerciceByIdUrl = `${API_URL}/api/exercices`
export const createExerciceUrl = `${API_URL}/api/exercices/create`
export const updateExerciceUrl = `${API_URL}/api/exercices/update`
export const deleteExerciceUrl = `${API_URL}/api/exercices/delete`
export const endExerciceUrl = `${API_URL}/api/exercices/do`
export const undoExerciceUrl = `${API_URL}/api/exercices/undo`
export const fetchAllExercicesUrl = `${API_URL}/api/exercices/all`

export const fetchVideoGalleryUrl = `${API_URL}/api/video-gallery`
export const fetchVideoGalleryByIdUrl = `${API_URL}/api/video-gallery`
export const fetchAllVideoGalleryUrl = `${API_URL}/api/video-gallery/all`
export const createVideoGalleryUrl = `${API_URL}/api/video-gallery/create`
export const updateVideoGalleryUrl = `${API_URL}/api/video-gallery/update`
export const deleteVideoGalleryUrl = `${API_URL}/api/video-gallery/delete`

// AI Quiz Competition API endpoints
export const fetchCompetitionsUrl = `${API_URL}/api/competitions`
export const fetchCompetitionByIdUrl = `${API_URL}/api/competitions`
export const createCompetitionUrl = `${API_URL}/api/competitions/create`
export const updateCompetitionUrl = `${API_URL}/api/competitions/update`
export const deleteCompetitionUrl = `${API_URL}/api/competitions/delete`
export const startCompetitionUrl = `${API_URL}/api/competitions`
export const submitCompetitionUrl = `${API_URL}/api/competitions/submit`
export const getCompetitionLeaderboardUrl = `${API_URL}/api/competitions`
export const getCompetitionRankUrl = `${API_URL}/api/competitions`
export const getCompetitionStatsUrl = `${API_URL}/api/competitions`
export const getUserCompetitionHistoryUrl = `${API_URL}/api/competitions/user/history`
export const getChildCompetitionScoresUrl = `${API_URL}/api/competitions/child`
export const getQuizStatusUrl = `${API_URL}/api/competitions/quiz`
/** GET /api/competitions/score/:scoreId/answers — Admin/Teacher only; 403 for students/parents */
export const getScoreAnswersUrl = `${API_URL}/api/competitions/score`
/** GET /api/champions-board — All competitions with top 3 + myResult for feed (no filters) */
export const getChampionsBoardUrl = `${API_URL}/api/champions-board`
/** POST /api/competitions/video/:videoId/scores/empty — Admin only; empty all quiz score cells for a video */
export const clearCompetitionScoresByVideoUrl = `${API_URL}/api/competitions/video`

/** GET /api/national-exams?subject=&type= — backend scopes results to the authenticated user (do not send level). */
export const nationalExamsUrl = `${API_URL}/api/national-exams`
/** Homepage slices: recommended, continue, catalog — see docs/frontend/NATIONAL-EXAMS-HOMEPAGE-ARCHITECTURE.md */
export const nationalExamsHomepageUrl = `${nationalExamsUrl}/homepage`
export const nationalExamsRecommendedUrl = `${nationalExamsUrl}/recommended`
export const nationalExamsPopularUrl = `${nationalExamsUrl}/popular`
export const nationalExamsContinueUrl = `${nationalExamsUrl}/continue`
export const nationalExamsCatalogUrl = `${nationalExamsUrl}/catalog`
export const nationalExamsHistoryUrl = `${nationalExamsUrl}/history`
/** Remove one continue row — `POST /api/national-exams/history/:examId` */
export const nationalExamHistoryItemUrl = (examId: string) =>
  `${nationalExamsHistoryUrl}/${encodeURIComponent(examId)}`
/** User bookmarks — `GET` list, `POST /saved` add `{ examId }`, `POST /saved/:examId` unsave */
export const nationalExamsSavedUrl = `${nationalExamsUrl}/saved`
export const nationalExamSavedItemUrl = (examId: string) =>
  `${nationalExamsSavedUrl}/${encodeURIComponent(examId)}`
export const nationalExamDownloadCountUrl = (examId: string) =>
  `${nationalExamsUrl}/${encodeURIComponent(examId)}/download`
/** Record view + trending — `POST` body `{ source: "web" | "mobile" }` */
export const nationalExamViewUrl = (examId: string) =>
  `${nationalExamsUrl}/${encodeURIComponent(examId)}/view`
/** Admin national exams: POST create; POST `/update` and `/delete` (body `{ id }`) like exercices/remarques; POST `/:id` partial update still available */
export const nationalExamsAdminUrl = `${API_URL}/api/admin/national-exams`
export const updateNationalExamAdminUrl = `${nationalExamsAdminUrl}/update`
export const deleteNationalExamAdminUrl = `${nationalExamsAdminUrl}/delete`

export const fetchExamsUrl = `${API_URL}/api/exams`
export const fetchExamByIdUrl = `${API_URL}/api/exams`
export const createExamUrl = `${API_URL}/api/exams/create`
export const updateExamUrl = `${API_URL}/api/exams/update`
export const deleteExamUrl = `${API_URL}/api/exams/delete`
export const endExamUrl = `${API_URL}/api/exams/do`
export const undoExamUrl = `${API_URL}/api/exams/undo`
export const fetchAllExamsUrl = `${API_URL}/api/exams/all`

export const fetchTypeExamsUrl = `${API_URL}/api/type-exams`
export const fetchTypeExamByIdUrl = `${API_URL}/api/type-exams`
export const createTypeExamUrl = `${API_URL}/api/type-exams/create`
export const updateTypeExamUrl = `${API_URL}/api/type-exams/update`
export const deleteTypeExamUrl = `${API_URL}/api/type-exams/delete`
export const suspendTypeExamUrl = `${API_URL}/api/type-exams/suspend`
export const activateTypeExamUrl = `${API_URL}/api/type-exams/activate`
export const fetchAllTypeExamsUrl = `${API_URL}/api/type-exams/all`

export const fetchRemarquesUrl = `${API_URL}/api/remarques`
export const fetchRemarqueByIdUrl = `${API_URL}/api/remarques`
export const createRemarqueUrl = `${API_URL}/api/remarques/create`
export const updateRemarqueUrl = `${API_URL}/api/remarques/update`
export const deleteRemarqueUrl = `${API_URL}/api/remarques/delete`
export const checkRemarqueUrl = `${API_URL}/api/remarques/check`
export const fetchAllRemarquesUrl = `${API_URL}/api/remarques/all`

export const fetchTypeRemarquesUrl = `${API_URL}/api/type-remarques`
export const fetchTypeRemarqueByIdUrl = `${API_URL}/api/type-remarques`
export const createTypeRemarqueUrl = `${API_URL}/api/type-remarques/create`
export const updateTypeRemarqueUrl = `${API_URL}/api/type-remarques/update`
export const deleteTypeRemarqueUrl = `${API_URL}/api/type-remarques/delete`
export const suspendTypeRemarqueUrl = `${API_URL}/api/type-remarques/suspend`
export const activateTypeRemarqueUrl = `${API_URL}/api/type-remarques/activate`
export const fetchAllTypeRemarquesUrl = `${API_URL}/api/type-remarques/all`

export const zadCategoriesUrl = `${API_URL}/api/zad/categories`
export const zadCategoryByIdUrl = (id: string) => `${API_URL}/api/zad/categories/${id}`
export const zadCategoryUpdateUrl = (id: string) => `${API_URL}/api/zad/categories/${id}/update`
export const zadCategoryStatusUrl = (id: string) => `${API_URL}/api/zad/categories/${id}/status`
export const zadProductTypesUrl = `${API_URL}/api/zad/product-types`
export const zadProductTypeByIdUrl = (id: string) => `${API_URL}/api/zad/product-types/${id}`
export const zadProductTypeUpdateUrl = (id: string) => `${API_URL}/api/zad/product-types/${id}/update`
export const zadProductTypeStatusUrl = (id: string) => `${API_URL}/api/zad/product-types/${id}/status`
export const zadImportUrl = `${API_URL}/api/zad/import`
export const zadProductsUrl = `${API_URL}/api/zad/products`
export const zadProductsImportUrl = `${API_URL}/api/zad/products/import`
export const zadProductByIdUrl = (id: string) => `${API_URL}/api/zad/products/${id}`
export const zadProductUpdateUrl = (id: string) => `${API_URL}/api/zad/products/${id}/update`
export const zadProductStatusUrl = (id: string) => `${API_URL}/api/zad/products/${id}/status`
export const zadProductGenerateBarcodeUrl = (id: string) =>
  `${API_URL}/api/zad/products/${id}/generate-barcode`
export const zadProductByBarcodeUrl = (barcode: string) =>
  `${API_URL}/api/zad/products/by-barcode/${encodeURIComponent(barcode)}`
export const zadLabelBatchesUrl = `${API_URL}/api/zad/label-batches`
export const zadLabelBatchByIdUrl = (id: string) => `${API_URL}/api/zad/label-batches/${id}`
export const zadLabelBatchUpdateUrl = (id: string) => `${API_URL}/api/zad/label-batches/${id}/update`
export const zadLabelBatchReadyUrl = (id: string) => `${API_URL}/api/zad/label-batches/${id}/ready`
export const zadLabelBatchCancelUrl = (id: string) => `${API_URL}/api/zad/label-batches/${id}/cancel`
export const zadLabelBatchRecordPrintUrl = (id: string) =>
  `${API_URL}/api/zad/label-batches/${id}/record-print`
export const zadLabelBatchRefreshPricesUrl = (id: string) =>
  `${API_URL}/api/zad/label-batches/${id}/refresh-prices`
export const zadStockUrl = `${API_URL}/api/zad/stock`
export const zadStockInitialUrl = `${API_URL}/api/zad/stock/initial`
export const zadStockAdjustmentUrl = `${API_URL}/api/zad/stock/adjustment`
export const zadStockProductUrl = (productId: string) =>
  `${API_URL}/api/zad/stock/products/${productId}`
export const zadStockMovementsUrl = `${API_URL}/api/zad/stock/movements`
export const zadStockMovementByIdUrl = (id: string) => `${API_URL}/api/zad/stock/movements/${id}`
export const zadStockReplenishmentUrl = `${API_URL}/api/zad/stock/replenishment`
export const zadProductReplenishmentUrl = (id: string) =>
  `${API_URL}/api/zad/products/${id}/replenishment`
export const zadProcurementDocumentsUrl = `${API_URL}/api/zad/procurement-documents`
export const zadProcurementDocumentByIdUrl = (id: string) =>
  `${API_URL}/api/zad/procurement-documents/${id}`
export const zadProcurementDocumentUpdateUrl = (id: string) =>
  `${API_URL}/api/zad/procurement-documents/${id}/update`
export const zadProcurementDocumentStatusUrl = (id: string) =>
  `${API_URL}/api/zad/procurement-documents/${id}/status`
export const zadProcurementDocumentQuoteUrl = (id: string) =>
  `${API_URL}/api/zad/procurement-documents/${id}/quote`
export const zadProcurementDocumentAttachmentsUrl = (id: string) =>
  `${API_URL}/api/zad/procurement-documents/${id}/attachments`
export const zadProcurementDocumentAttachmentRemoveUrl = (id: string, attachmentId: string) =>
  `${API_URL}/api/zad/procurement-documents/${id}/attachments/${attachmentId}/remove`
export const zadProcurementDocumentPrintUrl = (id: string) =>
  `${API_URL}/api/zad/procurement-documents/${id}/print`
export const zadProcurementDocumentConvertToPurchaseUrl = (id: string) =>
  `${API_URL}/api/zad/procurement-documents/${id}/convert-to-purchase`
export const zadSuppliersUrl = `${API_URL}/api/zad/suppliers`
export const zadSupplierByIdUrl = (id: string) => `${API_URL}/api/zad/suppliers/${id}`
export const zadSupplierUpdateUrl = (id: string) => `${API_URL}/api/zad/suppliers/${id}/update`
export const zadSupplierStatusUrl = (id: string) => `${API_URL}/api/zad/suppliers/${id}/status`
export const zadPurchasesUrl = `${API_URL}/api/zad/purchases`
export const zadPurchasesImportUrl = `${API_URL}/api/zad/purchases/import`
export const zadPurchaseByIdUrl = (id: string) => `${API_URL}/api/zad/purchases/${id}`
export const zadPurchaseUpdateUrl = (id: string) => `${API_URL}/api/zad/purchases/${id}/update`
export const zadPurchaseValidateUrl = (id: string) => `${API_URL}/api/zad/purchases/${id}/validate`
export const zadPurchaseCancelUrl = (id: string) => `${API_URL}/api/zad/purchases/${id}/cancel`
export const zadPurchaseCancellationPreviewUrl = (id: string) =>
  `${API_URL}/api/zad/purchases/${id}/cancellation-preview`
export const zadPurchaseForceCancelUrl = (id: string) =>
  `${API_URL}/api/zad/purchases/${id}/force-cancel`
export const zadPurchaseReconciliationSummaryUrl = `${API_URL}/api/zad/purchases/reconciliation-summary`
export const zadPurchaseReconciliationUrl = (id: string) =>
  `${API_URL}/api/zad/purchases/${id}/reconciliation`
export const zadProductRestoreUrl = (id: string) => `${API_URL}/api/zad/products/${id}/restore`
export const zadSupplierPaymentsUrl = `${API_URL}/api/zad/supplier-payments`
export const zadSupplierPaymentByIdUrl = (id: string) => `${API_URL}/api/zad/supplier-payments/${id}`
export const zadSupplierPaymentCancelUrl = (id: string) =>
  `${API_URL}/api/zad/supplier-payments/${id}/cancel`
export const zadSupplierPaymentSupplierSummaryUrl = (supplierId: string) =>
  `${API_URL}/api/zad/supplier-payments/suppliers/${supplierId}/summary`
export const zadSupplierPaymentPurchaseSummaryUrl = (purchaseId: string) =>
  `${API_URL}/api/zad/supplier-payments/purchases/${purchaseId}/summary`
export const zadCustomersUrl = `${API_URL}/api/zad/customers`
export const zadCustomerByIdUrl = (id: string) => `${API_URL}/api/zad/customers/${id}`
export const zadCustomerUpdateUrl = (id: string) => `${API_URL}/api/zad/customers/${id}/update`
export const zadCustomerStatusUrl = (id: string) => `${API_URL}/api/zad/customers/${id}/status`
export const zadCustomersMaarefatiSearchUrl = `${API_URL}/api/zad/customers/maarefati-search`
export const zadSalesUrl = `${API_URL}/api/zad/sales`
export const zadSaleByIdUrl = (id: string) => `${API_URL}/api/zad/sales/${id}`
export const zadSaleUpdateUrl = (id: string) => `${API_URL}/api/zad/sales/${id}/update`
export const zadSaleValidateUrl = (id: string) => `${API_URL}/api/zad/sales/${id}/validate`
export const zadSaleValidateAndCollectUrl = (id: string) =>
  `${API_URL}/api/zad/sales/${id}/validate-and-collect`
export const zadSalePromoCodePreviewUrl = (id: string) =>
  `${API_URL}/api/zad/sales/${id}/promo-code/preview`
export const zadSaleCancelUrl = (id: string) => `${API_URL}/api/zad/sales/${id}/cancel`
export const zadDeliveryNotesUrl = `${API_URL}/api/zad/delivery-notes`
export const zadDeliveryNoteByIdUrl = (id: string) => `${API_URL}/api/zad/delivery-notes/${id}`
export const zadDeliveryNoteBySaleUrl = (saleId: string) =>
  `${API_URL}/api/zad/delivery-notes/by-sale/${saleId}`
export const zadDeliveryNoteCancelUrl = (id: string) =>
  `${API_URL}/api/zad/delivery-notes/${id}/cancel`
export const zadCustomerPaymentsUrl = `${API_URL}/api/zad/customer-payments`
export const zadCustomerPaymentByIdUrl = (id: string) => `${API_URL}/api/zad/customer-payments/${id}`
export const zadCustomerPaymentCancelUrl = (id: string) =>
  `${API_URL}/api/zad/customer-payments/${id}/cancel`
export const zadCustomerPaymentCustomerSummaryUrl = (customerId: string) =>
  `${API_URL}/api/zad/customer-payments/customers/${customerId}/summary`
export const zadCustomerPaymentSaleSummaryUrl = (saleId: string) =>
  `${API_URL}/api/zad/customer-payments/sales/${saleId}/summary`
export const zadCustomerReturnsUrl = `${API_URL}/api/zad/customer-returns`
export const zadCustomerReturnByIdUrl = (id: string) => `${API_URL}/api/zad/customer-returns/${id}`
export const zadCustomerReturnUpdateUrl = (id: string) =>
  `${API_URL}/api/zad/customer-returns/${id}/update`
export const zadCustomerReturnValidateUrl = (id: string) =>
  `${API_URL}/api/zad/customer-returns/${id}/validate`
export const zadCustomerReturnCancelUrl = (id: string) =>
  `${API_URL}/api/zad/customer-returns/${id}/cancel`
export const zadCustomerReturnReturnableUrl = (saleId: string) =>
  `${API_URL}/api/zad/customer-returns/sales/${saleId}/returnable`
export const zadCustomerRefundsUrl = `${API_URL}/api/zad/customer-refunds`
export const zadCustomerRefundByIdUrl = (id: string) => `${API_URL}/api/zad/customer-refunds/${id}`
export const zadCustomerRefundCancelUrl = (id: string) =>
  `${API_URL}/api/zad/customer-refunds/${id}/cancel`
export const zadCustomerRefundCustomerSummaryUrl = (customerId: string) =>
  `${API_URL}/api/zad/customer-refunds/customers/${customerId}/summary`
export const zadReportsDashboardUrl = `${API_URL}/api/zad/reports/dashboard`
export const zadReportsSalesUrl = `${API_URL}/api/zad/reports/sales`
export const zadReportsPurchasesUrl = `${API_URL}/api/zad/reports/purchases`
export const zadReportsCustomerAccountsUrl = `${API_URL}/api/zad/reports/customer-accounts`
export const zadReportsSupplierAccountsUrl = `${API_URL}/api/zad/reports/supplier-accounts`
export const zadReportsStockUrl = `${API_URL}/api/zad/reports/stock`
export const zadReportsCashFlowUrl = `${API_URL}/api/zad/reports/cash-flow`
export const zadReportsAccountingUrl = `${API_URL}/api/zad/reports/accounting`
export const zadSalesHistorySummaryUrl = `${API_URL}/api/zad/reports/sales-history/summary`
export const zadSalesHistoryProductsUrl = `${API_URL}/api/zad/reports/sales-history/products`
export const zadSalesHistoryProductDetailUrl = (productId: string) =>
  `${API_URL}/api/zad/reports/sales-history/products/${productId}`
export const zadSalesHistorySalesUrl = `${API_URL}/api/zad/reports/sales-history/sales`
export const zadCatalogueUrl = `${API_URL}/api/zad/catalogue`
export const zadCatalogueByIdUrl = (id: string) => `${API_URL}/api/zad/catalogue/${id}`
export const zadCatalogueByProductUrl = (productId: string) =>
  `${API_URL}/api/zad/catalogue/by-product/${productId}`
export const zadCatalogueUpdateUrl = (id: string) => `${API_URL}/api/zad/catalogue/${id}/update`
export const zadCatalogueStatusUrl = (id: string) => `${API_URL}/api/zad/catalogue/${id}/status`
export const zadCatalogueImageUrl = (id: string) => `${API_URL}/api/zad/catalogue/${id}/image`
export const zadCatalogueImageRemoveUrl = (id: string) =>
  `${API_URL}/api/zad/catalogue/${id}/image/remove`
export const publicZadCatalogueUrl = `${API_URL}/api/public/zad/catalogue`
export const publicZadCatalogueByIdUrl = (id: string) => `${API_URL}/api/public/zad/catalogue/${id}`
export const publicZadPromotionsUrl = `${API_URL}/api/public/zad/promotions`

export const zadPromotionsUrl = `${API_URL}/api/zad/promotions`
export const zadPromotionsAnalyticsUrl = `${API_URL}/api/zad/promotions/analytics`
export const zadPromotionByIdUrl = (id: string) => `${API_URL}/api/zad/promotions/${id}`
export const zadPromotionUpdateUrl = (id: string) => `${API_URL}/api/zad/promotions/${id}/update`
export const zadPromotionStatusUrl = (id: string) => `${API_URL}/api/zad/promotions/${id}/status`
export const zadPromoCodesUrl = `${API_URL}/api/zad/promo-codes`
export const zadPromoCodesAnalyticsUrl = `${API_URL}/api/zad/promo-codes/analytics`
export const zadPromoCodeGenerateUrl = `${API_URL}/api/zad/promo-codes/generate`
export const zadPromoCodeStatusUrl = (id: string) => `${API_URL}/api/zad/promo-codes/${id}/status`
export const zadUnpaidFollowupsUrl = `${API_URL}/api/zad/unpaid-followups`
export const zadUnpaidFollowupSummaryUrl = `${API_URL}/api/zad/unpaid-followups/summary`
export const zadUnpaidFollowupCandidatesUrl = `${API_URL}/api/zad/unpaid-followups/candidates`
export const zadUnpaidFollowupTicketUrl = `${API_URL}/api/zad/unpaid-followups/ticket`
export const zadUnpaidFollowupMaarefatiUsersUrl = `${API_URL}/api/zad/unpaid-followups/maarefati-users`
export const zadUnpaidFollowupMeUrl = `${API_URL}/api/zad/unpaid-followups/me`
export const zadUnpaidFollowupByIdUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}`
export const zadUnpaidFollowupUpdateUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}/update`
export const zadUnpaidFollowupLinkSaleUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}/link-sale`
export const zadUnpaidFollowupUnlinkSaleUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}/unlink-sale`
export const zadUnpaidFollowupPromisesUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}/promises`
export const zadUnpaidFollowupContactsUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}/contacts`
export const zadUnpaidFollowupRemindersUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}/reminders`
export const zadUnpaidFollowupCloseUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}/close`
export const zadUnpaidFollowupReopenUrl = (id: string) => `${API_URL}/api/zad/unpaid-followups/${id}/reopen`
export const zadUnpaidFollowupPermissionUrl = `${API_URL}/api/zad/permissions/unpaid-followup`
export const zadUnpaidFollowupPermissionMeUrl = `${API_URL}/api/zad/permissions/unpaid-followup/me`
export const zadUnpaidFollowupPermissionAuditUrl = `${API_URL}/api/zad/permissions/unpaid-followup/audit`
export const zadSalesValidationPermissionUrl = `${API_URL}/api/zad/permissions/sales-validation`
export const zadSalesValidationPermissionMeUrl = `${API_URL}/api/zad/permissions/sales-validation/me`
export const zadSalesValidationPermissionAuditUrl = `${API_URL}/api/zad/permissions/sales-validation/audit`
export const zadIssuerProfileUrl = `${API_URL}/api/zad/issuer-profile`
export const zadIssuerProfileUpdateUrl = `${API_URL}/api/zad/issuer-profile/update`
export const zadIssuerProfileLogoUrl = `${API_URL}/api/zad/issuer-profile/logo`

export const fetchPaymentCategoriesUrl = `${API_URL}/api/payment-categories`
export const fetchPaymentCategoryByIdUrl = `${API_URL}/api/payment-categories`
export const createPaymentCategoryUrl = `${API_URL}/api/payment-categories/create`
export const updatePaymentCategoryUrl = `${API_URL}/api/payment-categories/update`
export const deletePaymentCategoryUrl = `${API_URL}/api/payment-categories/delete`
export const suspendPaymentCategoryUrl = `${API_URL}/api/payment-categories/suspend`
export const activatePaymentCategoryUrl = `${API_URL}/api/payment-categories/activate`
export const fetchAllPaymentCategoriesUrl = `${API_URL}/api/payment-categories/all`
// Class fees endpoints
export const getCategoriesForClassUrl = `${API_URL}/api/payment-categories/for-class`
export const getFeeForCategoryAndClassUrl = `${API_URL}/api/payment-categories`
export const updateClassFeeUrl = `${API_URL}/api/payment-categories`

export const fetchPaymentsUrl = `${API_URL}/api/payments`
export const fetchPaymentByIdUrl = (id: string) => `${API_URL}/api/payments/${id}`
export const historicalPaymentCandidatesUrl = (userId: string) =>
  `${API_URL}/api/payments/historical-candidates/${userId}`
export const linkHistoricalPaymentUrl = (paymentId: string) =>
  `${API_URL}/api/payments/${paymentId}/link-user`
export const createPaymentUrl = `${API_URL}/api/payments/create`
export const updatePaymentUrl = `${API_URL}/api/payments/update`
export const deletePaymentUrl = `${API_URL}/api/payments/delete`
export const suspendPaymentUrl = `${API_URL}/api/payments/suspend`
export const activatePaymentUrl = `${API_URL}/api/payments/activate`

// Billing (student charges + payment allocations — additive; does not replace /api/payments)
export const billingChargesUrl = `${API_URL}/api/billing/charges`
export const billingChargesCreateUrl = `${API_URL}/api/billing/charges/create`
export const billingChargesCreateFromTariffUrl = `${API_URL}/api/billing/charges/create-from-tariff`
export const billingChargesWaiveUrl = `${API_URL}/api/billing/charges/waive`
export const billingChargesCancelUrl = `${API_URL}/api/billing/charges/cancel`
export const billingChargesDeleteUrl = `${API_URL}/api/billing/charges/delete`
export const billingStudentChargesUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/charges`
/** Read-only charge-based period timeline (same auth as /charges). */
export const billingStudentPeriodStatusUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/period-status`
/** Read-only balance snapshot (excludes cancelled/waived per BILLING-API). */
export const billingStudentBalanceUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/balance`
export const billingStudentOverdueSummaryUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/overdue-summary`
/** Payment-centric reporting projection for a student (not charge balance source of truth). */
export const billingStudentPaymentsUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/payments`
export const billingStudentAmountOptionsUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/amount-options`
export const billingStudentPreviewTotalUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/preview-total`
export const billingParentSummaryUrl = `${API_URL}/api/billing/parent/summary`
export const billingAllocationsApplyUrl = `${API_URL}/api/billing/allocations/apply`
export const billingAllocationsRemoveUrl = `${API_URL}/api/billing/allocations/remove`
export const billingPaymentAllocationsUrl = (paymentId: string) =>
  `${API_URL}/api/billing/payments/${paymentId}/allocations`
/** Optional: all PaymentAllocation rows for a student (Payé source of truth). */
export const billingStudentAllocationsUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/allocations`
/** Staff: PaymentAllocation breakdown for a receipt (after apply / apply-fifo). */
export const billingPaymentCoverageUrl = (paymentId: string) =>
  `${API_URL}/api/billing/payments/${paymentId}/coverage`
export const billingReportsOverdueUrl = `${API_URL}/api/billing/reports/overdue`
export const billingReportsSyncOverdueUrl = `${API_URL}/api/billing/reports/sync-overdue`
export const billingPolicyUrl = (establishmentId: string) =>
  `${API_URL}/api/billing/policy/${establishmentId}`
export const billingPolicyUpsertUrl = `${API_URL}/api/billing/policy/upsert`
export const billingPolicyPeriodsUrl = (establishmentId: string) =>
  `${API_URL}/api/billing/policy/${establishmentId}/periods`
export const billingChargesGenerateForStudentUrl = `${API_URL}/api/billing/charges/generate-for-student`
export const billingAllocationsApplyFifoUrl = `${API_URL}/api/billing/allocations/apply-fifo`
export const billingPricingResolveUrl = `${API_URL}/api/billing/pricing/resolve`
export const billingStudentFeeAgreementsUrl = (studentId: string) =>
  `${API_URL}/api/billing/student/${studentId}/fee-agreements`
export const billingFeeAgreementsUpsertUrl = `${API_URL}/api/billing/fee-agreements/upsert`
export const billingFeeAgreementsDeleteUrl = `${API_URL}/api/billing/fee-agreements/delete`
export const billingSchedulesUrl = (establishmentId: string) =>
  `${API_URL}/api/billing/schedules/${establishmentId}`
export const billingSchedulesCreateUrl = `${API_URL}/api/billing/schedules/create`
export const billingSchedulesUpdateUrl = `${API_URL}/api/billing/schedules/update`
export const billingSchedulesDeleteUrl = `${API_URL}/api/billing/schedules/delete`

export const billingVerificationStudentUrl = (studentId: string) =>
  `${API_URL}/api/billing/verification/student/${studentId}`
export const billingVerificationCategoryUrl = (studentId: string, categoryId: string) =>
  `${API_URL}/api/billing/verification/student/${studentId}/category/${categoryId}`

/** Manual billing reminders (staff-only POST). See docs/frontend/BILLING-NOTIFICATIONS.md */
export const billingNotificationPreviewUrl = (studentId: string) =>
  `${API_URL}/api/billing-notifications/preview/${studentId}`
export const billingNotificationSendUrl = (studentId: string) =>
  `${API_URL}/api/billing-notifications/send/${studentId}`
export const billingNotificationSendBulkUrl = `${API_URL}/api/billing-notifications/send-bulk`

export const fetchPeriodsUrl = `${API_URL}/api/periods`
export const fetchPeriodByIdUrl = `${API_URL}/api/periods`
export const fetchAllPeriodsUrl = `${API_URL}/api/periods/all`
export const createPeriodUrl = `${API_URL}/api/periods/create`
export const updatePeriodUrl = `${API_URL}/api/periods/update`
export const deletePeriodUrl = `${API_URL}/api/periods/delete`
export const suspendPeriodUrl = `${API_URL}/api/periods/suspend`
export const activatePeriodUrl = `${API_URL}/api/periods/activate`

export const fetchNotificationsUrl = `${API_URL}/api/notifications`
export const notificationsCountUrl = `${API_URL}/api/notifications/count`
export const updateNotificationUrl = `${API_URL}/api/notifications/seen`
export const markAllNotificationsReadUrl = `${API_URL}/api/notifications/mark-all-read`
export const deleteNotificationUrl = (id: string) => `${API_URL}/api/notifications/${id}`

/** GET /api/chat/admin-status — is admin online? (any authenticated user) */
export const adminStatusUrl = `${API_URL}/api/chat/admin-status`

/** Chat AI (OpenRouter). Per docs/frontend/CHAT-AI-OPENROUTER.md. GET = get/create AI conversation (non-admin); 403 admin, 503 if not configured. */
export const chatAiConversationUrl = `${API_URL}/api/chat/ai/conversation`
/** POST = send message to AI; body { conversationId, content }; returns { userMessage, aiMessage, conversationId }. 503 if key/bot missing. */
export const chatAiMessageUrl = `${API_URL}/api/chat/ai/message`

/** Support chat with admin: conversations and messages (saved, persisted) */
export const chatConversationsUrl = `${API_URL}/api/chat/conversations`
export const chatConversationWithAdminUrl = `${API_URL}/api/chat/conversations/with-admin`
/** POST /api/chat/conversations/with-user/:userId — get or create conversation with a specific user (admin only) */
export const chatConversationWithUserUrl = (userId: string) =>
  `${API_URL}/api/chat/conversations/with-user/${userId}`
/** POST /api/chat/conversations/start-new — archive current conversation and create new active one; history kept (non-admin only) */
export const chatStartNewConversationUrl = `${API_URL}/api/chat/conversations/start-new`
export const chatConversationMessagesUrl = (id: string) =>
  `${API_URL}/api/chat/conversations/${id}/messages`
/** GET /api/chat/rooms/:roomId/messages — messages by roomId (e.g. after refresh when only roomId available) */
export const chatRoomMessagesUrl = (roomId: string) =>
  `${API_URL}/api/chat/rooms/${encodeURIComponent(roomId)}/messages`
export const chatSendMessageUrl = `${API_URL}/api/chat/messages`
export const chatMarkConversationReadUrl = (id: string) =>
  `${API_URL}/api/chat/conversations/${id}/read`
/** DELETE /api/chat/conversations/:id — delete conversation and all messages (admin only) */
export const chatDeleteConversationUrl = (id: string) => `${API_URL}/api/chat/conversations/${id}`

// Chatbot API endpoints (Q&A management)
export const fetchChatbotResponsesUrl = `${API_URL}/api/chatbot/responses`
export const fetchChatbotActiveResponsesUrl = `${API_URL}/api/chatbot/active-responses`
export const createChatbotResponseUrl = `${API_URL}/api/chatbot/responses`
export const updateChatbotResponseUrl = (id: string) => `${API_URL}/api/chatbot/responses/${id}`
export const deleteChatbotResponseUrl = (id: string) => `${API_URL}/api/chatbot/responses/${id}`
export const toggleChatbotResponseStatusUrl = (id: string) => `${API_URL}/api/chatbot/responses/${id}/toggle-status`
export const searchChatbotResponsesUrl = `${API_URL}/api/chatbot/search`

// Inventory Management API endpoints
export const inventoryUrl = `${API_URL}/api/inventory`
export const inventoryTypesUrl = `${API_URL}/api/inventory-types`
export const createInventoryUrl = `${API_URL}/api/inventory/create`
export const updateInventoryUrl = `${API_URL}/api/inventory/update`
export const deleteInventoryUrl = `${API_URL}/api/inventory/delete`
export const assignInventoryUrl = `${API_URL}/api/inventory/assign`
export const unassignInventoryUrl = `${API_URL}/api/inventory/unassign`
export const maintenanceInventoryUrl = `${API_URL}/api/inventory/maintenance`

// Inventory Types API endpoints
export const createInventoryTypeUrl = `${API_URL}/api/inventory-types/create`
export const updateInventoryTypeUrl = `${API_URL}/api/inventory-types/update`
export const deleteInventoryTypeUrl = `${API_URL}/api/inventory-types/delete`
export const activateInventoryTypeUrl = `${API_URL}/api/inventory-types/activate`
export const suspendInventoryTypeUrl = `${API_URL}/api/inventory-types/suspend`

// Expense Management API endpoints (All mutations use POST to avoid CORS)
export const fetchExpensesUrl = `${API_URL}/api/expenses`
export const fetchExpenseByIdUrl = (id: string) => `${API_URL}/api/expenses/${id}`

export const foldersUrl = `${API_URL}/api/folders`
export const folderTreeUrl = `${foldersUrl}/tree`
export const folderUpdateUrl = (folderId: string) => `${foldersUrl}/${folderId}/update`
export const folderDeleteUrl = (folderId: string) => `${foldersUrl}/${folderId}/delete`

export const filesUrl = `${API_URL}/api/files`
export const fileUpdateUrl = (fileId: string) => `${filesUrl}/${fileId}/update`
export const fileDownloadUrl = (fileId: string) => `${filesUrl}/${fileId}/download`
export const fileTrashUrl = (fileId: string) => `${filesUrl}/${fileId}/trash`
export const fileRestoreUrl = (fileId: string) => `${filesUrl}/${fileId}/restore`
export const filePermanentDeleteUrl = (fileId: string) => `${filesUrl}/${fileId}/delete`
export const fileAddLabelUrl = (fileId: string) => `${filesUrl}/${fileId}/labels/add`
export const fileRemoveLabelUrl = (fileId: string) => `${filesUrl}/${fileId}/labels/remove`
export const fileFlagUrl = (fileId: string, flagType: string) => `${filesUrl}/${fileId}/flags/${flagType}`
export const fetchRolesUrl = `${API_URL}/api/roles`
export const createExpenseUrl = `${API_URL}/api/expenses`
export const updateExpenseUrl = `${API_URL}/api/expenses/update` // POST method
export const deleteExpenseUrl = `${API_URL}/api/expenses/delete` // POST method

// Push notification subscriptions
export const subscribePushUrl = `${API_URL}/api/push-subscriptions/subscribe`
export const unsubscribePushUrl = `${API_URL}/api/push-subscriptions/unsubscribe`

// Payroll API endpoints
export const fetchPayslipsUrl = `${API_URL}/api/payroll`
export const fetchAllPayslipsUrl = `${API_URL}/api/payroll/all`
export const fetchPayslipsByUserUrl = (userId: string) => `${API_URL}/api/payroll/user/${userId}`
export const fetchPayslipsByPeriodUrl = (month: number, year: number) => `${API_URL}/api/payroll/period/${month}/${year}`
export const fetchPayslipByIdUrl = (id: string) => `${API_URL}/api/payroll/${id}`
export const createPayslipUrl = `${API_URL}/api/payroll/create`
export const updatePayslipUrl = `${API_URL}/api/payroll/update`
export const finalizePayslipUrl = `${API_URL}/api/payroll/finalize`
export const markPayslipPaidUrl = `${API_URL}/api/payroll/mark-paid`
export const deletePayslipUrl = `${API_URL}/api/payroll/delete`
export const fetchDeletedPayslipsUrl = `${API_URL}/api/payroll/deleted`
export const restorePayslipUrl = `${API_URL}/api/payroll/restore`

// Payroll Categories API endpoints
export const fetchPayrollCategoriesUrl = `${API_URL}/api/payroll-categories`
export const fetchPayrollCategoryByIdUrl = (id: string) => `${API_URL}/api/payroll-categories/${id}`
export const fetchAllPayrollCategoriesUrl = `${API_URL}/api/payroll-categories/all`
export const createPayrollCategoryUrl = `${API_URL}/api/payroll-categories/create`
export const updatePayrollCategoryUrl = `${API_URL}/api/payroll-categories/update`
export const deletePayrollCategoryUrl = `${API_URL}/api/payroll-categories/delete`
export const suspendPayrollCategoryUrl = `${API_URL}/api/payroll-categories/suspend`
export const activatePayrollCategoryUrl = `${API_URL}/api/payroll-categories/activate`

// Administrative documents (templates + generated PDFs)
export const documentTemplatesUrl = `${API_URL}/api/document-templates`
export const documentTemplatesUpdateUrl = `${API_URL}/api/document-templates/update`
export const documentTemplatesDeleteUrl = `${API_URL}/api/document-templates/delete`
export const documentsUrl = `${API_URL}/api/documents`
export const documentsGenerateUrl = `${API_URL}/api/documents/generate`
export const documentByIdUrl = (id: string) => `${API_URL}/api/documents/${id}`
/** Stream/download generated file (PDF preferred). */
export const documentDownloadUrl = (id: string) => `${API_URL}/api/documents/${id}/download`
export const documentPrintUrl = (id: string) => `${API_URL}/api/documents/${id}/print`
export const documentHistoryUrl = (id: string) => `${API_URL}/api/documents/${id}/history`
export const documentArchiveUrl = (id: string) => `${API_URL}/api/documents/${id}/archive`
export const documentsDeleteUrl = `${API_URL}/api/documents/delete`
export const documentDeleteByIdUrl = (id: string) => `${API_URL}/api/documents/${id}/delete`
export const documentVerifyUrl = (code: string) => `${API_URL}/api/documents/verify/${code}`

/** Maarefati school accounting (isolated from ZAD). */
export const accountingSummaryUrl = `${API_URL}/api/accounting/summary`
export const accountingPaymentsUrl = `${API_URL}/api/accounting/payments`
export const accountingExpensesUrl = `${API_URL}/api/accounting/expenses`
export const accountingExpenseByIdUrl = (id: string) => `${API_URL}/api/accounting/expenses/${id}`
export const accountingExpenseUpdateUrl = (id: string) => `${API_URL}/api/accounting/expenses/${id}/update`
export const accountingExpenseValidateUrl = (id: string) => `${API_URL}/api/accounting/expenses/${id}/validate`
export const accountingExpensePaymentsUrl = (id: string) => `${API_URL}/api/accounting/expenses/${id}/payments`
export const accountingExpenseCancelUrl = (id: string) => `${API_URL}/api/accounting/expenses/${id}/cancel`
export const accountingExpenseDocumentsUrl = (id: string) =>
  `${API_URL}/api/accounting/expenses/${id}/documents`
export const accountingExpenseAttachmentsUrl = (id: string) =>
  `${API_URL}/api/accounting/expenses/${id}/attachments`
export const accountingExpenseAttachmentDownloadUrl = (id: string, attachmentId: string) =>
  `${API_URL}/api/accounting/expenses/${id}/attachments/${attachmentId}/download`
export const accountingExpenseAttachmentByIdUrl = (id: string, attachmentId: string) =>
  `${API_URL}/api/accounting/expenses/${id}/attachments/${attachmentId}`
export const accountingExpenseInvoiceUrl = (id: string) => `${API_URL}/api/accounting/expenses/${id}/invoice`
export const accountingExpenseWithholdingReviewUrl = (id: string) =>
  `${API_URL}/api/accounting/expenses/${id}/withholding/review`
export const accountingExpenseTejUrl = (id: string) => `${API_URL}/api/accounting/expenses/${id}/tej`
export const accountingInvoiceFollowUpsUrl = `${API_URL}/api/accounting/invoice-followups`
export const accountingInvoiceFollowUpStatsUrl = `${API_URL}/api/accounting/invoice-followups/stats`
export const accountingSuppliersLookupUrl = `${API_URL}/api/accounting/suppliers/lookup`
export const accountingInvoiceFollowUpEmailReminderPrepareUrl = (id: string) =>
  `${API_URL}/api/accounting/invoice-followups/${id}/email-reminders/prepare`
export const accountingInvoiceFollowUpEmailReminderSendUrl = (id: string) =>
  `${API_URL}/api/accounting/invoice-followups/${id}/email-reminders/send`
export const accountingInvoiceFollowUpEmailReminderStatusUrl = (id: string) =>
  `${API_URL}/api/accounting/invoice-followups/${id}/email-reminders/status`
export const accountingInvoiceFollowUpRemindersUrl = (id: string) =>
  `${API_URL}/api/accounting/invoice-followups/${id}/reminders`
export const accountingInvoiceFollowUpManualRemindersUrl = (id: string) =>
  `${API_URL}/api/accounting/invoice-followups/${id}/manual-reminders`
export const accountingInvoiceFollowUpByIdUrl = (id: string) =>
  `${API_URL}/api/accounting/invoice-followups/${id}`
export const accountingInvoiceFollowUpContactUrl = (id: string) =>
  `${API_URL}/api/accounting/invoice-followups/${id}/contact`
export const accountingInvoiceFollowUpScheduleUrl = (id: string) =>
  `${API_URL}/api/accounting/invoice-followups/${id}/schedule`
export const accountingWithholdingPendingUrl = `${API_URL}/api/accounting/withholding/pending`
export const accountingTejPendingUrl = `${API_URL}/api/accounting/tej/pending`
export const accountingTicketsUrl = `${API_URL}/api/accounting/tickets`
export const accountingTicketByIdUrl = (id: string) => `${API_URL}/api/accounting/tickets/${id}`
export const accountingTicketPrintHistoryUrl = (id: string) =>
  `${API_URL}/api/accounting/tickets/${id}/print-history`
export const accountingTicketPrintEventsUrl = (id: string) =>
  `${API_URL}/api/accounting/tickets/${id}/print-events`
export const accountingReportUrl = (type: string) => `${API_URL}/api/accounting/reports/${type}`
export const accountingAuditUrl = `${API_URL}/api/accounting/audit`